import { useState } from 'react';
import axios from 'axios';
import { SLOT_LABELS } from './SubscriptionDeliveryCard';

const API_BASE = 'https://teardrophydro.co.uk/garageFarm';

// Same-day delivery farm: any order placed on an earlier calendar day and
// still unfulfilled is properly overdue; one placed today just needs
// attention today.
export function orderUrgency(order) {
  const placed = order.timestamp ? new Date(order.timestamp) : null;
  const startOfToday = new Date(new Date().setHours(0, 0, 0, 0));
  const isOverdue = !!placed && placed < startOfToday;
  const isToday = !!placed && !isOverdue;
  return { isOverdue, isToday };
}

export const OrderDeliveryCard = ({ order, onDone, compact = false }) => {
  const [state, setState] = useState('idle'); // idle | saving | done | error

  const token = () => localStorage.getItem('accessToken');

  const markDelivered = async () => {
    setState('saving');
    try {
      await axios.patch(`${API_BASE}/orders/${order._id}/fulfilled`,
        { fulfilled: true },
        { headers: { Authorization: `Bearer ${token()}` } }
      );
      setState('done');
      setTimeout(onDone, 1000);
    } catch {
      setState('error');
    }
  };

  const addrStr = order.address?.line1
    ? [order.address.line1, order.address.line2, order.address.city, order.address.postcode].filter(Boolean).join(', ')
    : null;

  const placedLabel = order.timestamp
    ? new Date(order.timestamp).toLocaleString('en-GB', { weekday: 'short', hour: '2-digit', minute: '2-digit' })
    : '-';

  const { isOverdue } = orderUrgency(order);
  const urgencyLabel = isOverdue ? 'Overdue' : 'Today';
  const urgencyColor = isOverdue ? '#dc2626' : '#d97706';

  return (
    <div style={{
      background: 'var(--panel)', border: '1px solid var(--border)', borderRadius: 'var(--r-xl)',
      padding: compact ? '10px 12px' : '14px 16px', display: 'flex', flexDirection: 'column', gap: compact ? 4 : 8,
      borderLeft: `4px solid ${urgencyColor}`,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
        <div>
          <div style={{ fontWeight: 700, fontSize: 14 }}>{order.name || '-'}</div>
          {!compact && order.phone && <a href={`tel:${order.phone}`} style={{ fontSize: 12, color: 'var(--brand-2)', textDecoration: 'none' }}>📞 {order.phone}</a>}
          {!compact && !order.phone && order.email && <div style={{ fontSize: 12, color: 'var(--muted)' }}>{order.email}</div>}
        </div>
        <span style={{ background: urgencyColor, color: '#fff', fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 99, whiteSpace: 'nowrap' }}>
          {urgencyLabel}
        </span>
      </div>

      <div style={{ fontSize: 12, color: 'var(--text)', lineHeight: 1.5 }}>
        {(order.items || []).filter(i => !i.isDelivery).map(i => `${i.name}${i.quantity ? ` ×${i.quantity}` : ''}`).join(', ') || 'Order'}
      </div>

      {!compact && addrStr && <div style={{ fontSize: 12, color: 'var(--muted)' }}>📍 {addrStr}</div>}
      {!compact && order.deliveryInstructions && <div style={{ fontSize: 12, color: 'var(--muted)', fontStyle: 'italic' }}>"{order.deliveryInstructions}"</div>}
      {order.deliverySlot && <div style={{ fontSize: 12, color: 'var(--muted)' }}>🕐 {SLOT_LABELS[order.deliverySlot] || order.deliverySlot}</div>}
      <div style={{ fontSize: 12, color: 'var(--muted)' }}>
        {order.paymentMethod === 'cash' ? `💵 Cash · £${(order.total || 0).toFixed(2)}` : `💳 £${(order.total || 0).toFixed(2)}`} · placed {placedLabel}
      </div>

      {!compact && (
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 4 }}>
          {state === 'done' ? (
            <span style={{ fontSize: 12, color: '#16a34a', fontWeight: 600 }}>✓ Marked delivered</span>
          ) : (
            <>
              <button
                onClick={markDelivered}
                disabled={state === 'saving'}
                style={{ background: 'var(--panel-2)', color: 'var(--muted)', border: 'none', borderRadius: 'var(--r-md)', padding: '6px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
              >
                Mark delivered
              </button>
              {state === 'error' && <span style={{ fontSize: 12, color: '#dc2626' }}>Failed - try again</span>}
            </>
          )}
        </div>
      )}
    </div>
  );
};
